import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root'
})
export class ContextService {
	client;
	// this.contextService.client.clientId
	// this.contextService.client.procoreCompanyId
	// this.contextService.client.dropboxExportParentFolderId

	procoreIsSandbox;
	// this.contextService.procoreIsSandbox = true or false

	procoreAuthCode;
	// this.contextService.procoreAuthCode = "12345"

	procoreUserInfo: any;
	// this.contextService.procoreUserInfo.email = "brad.hickey@shakeit.ai"
	// this.contextService.procoreUserInfo.name = "Brad Hickey"
	// this.contextService.procoreUserInfo.procoreUserId = "12345"
	// this.contextService.procoreUserInfo.isAdmin = true or false
	// this.contextService.procoreUserInfo.companyName = "Shake IT"

	procoreContextObject: any;
	// this.contextService.procoreContextObject.context.company_id = "4265852"
	// this.contextService.procoreContextObject.context.id = "19111"
	// this.contextService.procoreContextObject.context.object_id = "19111"
	// this.contextService.procoreContextObject.context.procore_api_base_url = "https://sandbox.procore.com"
	// this.contextService.procoreContextObject.context.project_id = "120637"
	// this.contextService.procoreContextObject.context.route = "/:project_id/project/prime_contracts/:prime_contract_id/change_orders/potential_change_orders/:id"
	// this.contextService.procoreContextObject.context.view = "prime_contracts.change_orders.detail"
	// this.contextService.procoreContextObject.context.generatedFileUrl = "https://sandbox.procore.com/rest/v1.0/companies/4265852/invoices/async_jobs/5ecedcf1-ea08-43a8-9dfa-307ff0a32b9c"
	// this.contextService.procoreContextObject.context.generatedFileType = "coversheet" or "pdf"

	dropboxAccount: any;
	// this.contextService.dropboxAccount.teamMemberId = "dbmid: AADCJKxbHOBu9MKVx6zK5wFZ8uv_A4SPMUg"
	// this.contextService.dropboxAccount.email = "brad.hickey@shakeit.ai"
	// this.contextService.dropboxAccount.name.abbreviatedName = "BH"
	// this.contextService.dropboxAccount.name.displayName = "Brad Hickey"

	constructor() { }
}
